import { SET_LOCATION, SET_VPT_STATUS, SET_ELIGIBLE_LOCATIONS, SET_DEVICE_TYPE, SET_MODAL_DATA, SET_SHOW_MODAL, SET_SHOW_LOCATION_PROMPT_OVERLAY, SET_SHOW_IN_APP_NOTIFICATION_OVERLAY, SET_IN_APP_NOTIFICATION_OVERLAY_DATA } from "./types";
import { apiCallV2 } from "../../../utils/api";

export const SetDeviceType = () => async (dispatch, getState) => {
    const platform = localStorage.getItem("indi-platform");
    dispatch({
        type: SET_DEVICE_TYPE,
        deviceType: platform && platform != null && platform != "null" ? "mobile" : "web",
    });
};

export const SetLocation = (data) => async (dispatch, getState) => {
    dispatch({
        type: SET_LOCATION,
        location: data,
    });
};

export const SetModalProperties = (data) => async (dispatch, getState) => {
    dispatch({
        type: SET_MODAL_DATA,
        modalData: data,
    });
};

export const ShowModal =
    (bool = true) =>
        async (dispatch, getState) => {
            dispatch({
                type: SET_SHOW_MODAL,
                bool: bool,
            });
        };

export const SetShowLocationPromptOverlay =
    (bool = true) =>
        async (dispatch, getState) => {
            dispatch({
                type: SET_SHOW_LOCATION_PROMPT_OVERLAY,
                bool: bool,
            });
        };

export const SetShowInAppNotificationOverlay =
    (bool = true) =>
        async (dispatch, getState) => {
            dispatch({
                type: SET_SHOW_IN_APP_NOTIFICATION_OVERLAY,
                bool: bool,
            });
        };

export const SetInAppNotificationOverlayData = (data) => async (dispatch, getState) => {
    dispatch({
        type: SET_IN_APP_NOTIFICATION_OVERLAY_DATA,
        data: data,
    });
};

export const GetEligibleLocations = (data) => async (dispatch, getState) => {
    const res = await apiCallV2("GET", "admin/eligible-locations/get", "", localStorage.getItem("access-token"), "", false);

    dispatch({
        type: SET_ELIGIBLE_LOCATIONS,
        list: res?.data || [],
    });
};

export const SetVPTStatus =
    (status) =>
        async (dispatch, getState) => {
            dispatch({
                type: SET_VPT_STATUS,
                status: status,
            });
        };

export const CheckLocationEligibility = (region, location = {}) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "check-location-eligibility",
        {
            region: region,
        },
        localStorage.getItem("access-token")
    );

    const isEligible = res?.data?.data?.isEligible;

    if (isEligible) {
        dispatch({
            type: SET_LOCATION,
            location: location,
        });
    }

    dispatch({
        type: SET_VPT_STATUS,
        status: isEligible ? 1 : 0,
    });

};

export const NewError = (error) => async (dispatch, getState) => {
    try {
        const platform = localStorage.getItem("indi-platform");
        const res = await apiCallV2(
            "POST",
            "error-log/new",
            {
                platform: (platform == "null" || !platform) ? "web" : platform,
                location: "INDI-APP",
                error: JSON.stringify(error)
            },
            localStorage.getItem("access-token")
        );
    } catch (e) {
        return null;
    }
}